<template>
  <div class="processing">
    <circle-stage>
      <template slot="headline">
        {{ $t('Processing.headline') }}
        <loading-icon />
      </template>
    </circle-stage>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import env from '@/env';
import { STATUS } from '@/api/';
import CircleStage from '@/components/CircleStage/CircleStage.vue';

import LoadingIcon from '@/components/LoadingIcon/LoadingIcon.vue';

export default {
  name: 'Processing',
  components: {
    CircleStage,
    LoadingIcon,
  },
  computed: {
    ...mapGetters({
      status: 'streamcast/status',
      credentials: 'streamcast/credentials',
    }),
  },
  async mounted() {
    const vm = this;

    // try to authenticate right away based on the query
    const {
      client_ip: clientIp,
      client_mac: clientMac,
      site_id: siteId,
      signature,
    } = vm.$router.currentRoute.query;

    const { authenticationCode } = vm.$router.currentRoute.params;

    vm.$store.commit('streamcast/credentials', {
      clientIp,
      clientMac,
      siteId,
      signature,
      authenticationCode,
    });

    // wait some time before performing the request
    // this ensures that users have the chance of understanding what is happening
    // however, once successful, the TV and this page will switch more or less simultaneously
    await new Promise((resolve) => {
      setTimeout(resolve, env.MINIMUM_TIMER || 3000);
    });

    vm.$store.dispatch('streamcast/authenticate')
      .catch(() => {}) // avoid any unhandled errors
      .finally(() => {
        // make sure that the update propagated properly
        vm.$nextTick(() => {
          if (vm.status === STATUS.READY) {
            // route guard intervention might fire (unhandled) exceptions
            // which are totally fine but need to be handled for Cypress
            vm.$router.push({ name: 'Success' }).catch(() => {});
            return;
          }

          if (vm.status === STATUS.WRONG_CODE) {
            vm.$router.push({ name: 'ManualEntry', params: { error: 'error' } }).catch(() => {});
            return;
          }

          if (vm.status === STATUS.MISSING_INFORMATION) {
            if (authenticationCode) {
              vm.$router.push({ name: 'ErrorNetworkProcessing', params: vm.$router.currentRoute.params }).catch(() => {});
            } else {
              vm.$router.push({ name: 'ErrorNetworkBlank' }).catch(() => {});
            }
            return;
          }

          // loading state (STATUS.LOADING) or anything else... retry:
          window.location.reload();
        });
      });
  },
};
</script>

<style lang="scss" scoped>
svg {
  display: block;
  width: 60px;
  margin: 0 auto;
  margin-top: calc(3 * var(--spacing-side));
}
</style>
